import { useEffect, useState, useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom"; 
import ApplyPage from "./ApplyPage"; 
import { insertCase } from "../services/api"; 

/**
 * ApplyPageWrapper handles the initial creation of a new case before loading the ApplyPage.
 * It uses the serviceId from the URL to create the case.
 */
function ApplyPageWrapper() {
  // Use useParams to get the serviceId from the route path: /apply/:serviceId
  const { serviceId } = useParams();
  const [searchParams] = useSearchParams();

  const existingCaseId = searchParams.get('caseId');
  
  const [loading, setLoading] = useState(true);
  const [caseId, setCaseId] = useState(existingCaseId); 
  const [error, setError] = useState(null);
  const hasRun = useRef(false);

  useEffect(() => {
    if (existingCaseId) {
        setLoading(false);
        return; // *** Skip API call if caseId is already in the URL ***
    }
    
    // Check if serviceId is available before attempting the API call
    if (!serviceId) {
        setError("Service ID not found in the URL.");
        setLoading(false);
        return;
    }
    
    // This part prevents the effect from running twice in React's Strict Mode (Development)
    if (hasRun.current) return; 
    hasRun.current = true;

    const createCase = async () => {
      try {
        // 1. Call the API to create a new case, passing serviceId in the request body.
        
        // Assuming your `insertCase` helper is adjusted to send the serviceId:
        const response = await insertCase({ serviceId: serviceId }); 
        console.log("response:", response);
        
        // 2. Set the case ID from the API response. 
        // Based on your server code, the response is expected to be { id: newCase.id, ... }
        setCaseId(response.data.id); 

      } catch (err) {
        console.error("Error creating case:", err.message);
        setError("Failed to create a new application case. Please check your connection."); 
      } finally {
        setLoading(false);
      }
    };

    createCase();
  }, [serviceId]); // Added serviceId to dependencies to be clean, though it won't change here

  // --- Rendering Logic ---

  if (loading) {
    return <div>Initialising Application...</div>;
  }

  if (error || !caseId) {
    // Show an error message if creation failed or ID is somehow missing
    console.log("error", caseId, error);
    return <div>Error: {caseId || "**Unable to start new application.**"}</div>;
  }

  // If successful, render the main application page and pass the persistent caseId and serviceId
  return <ApplyPage caseId={caseId} serviceId={serviceId} />;
}

export default ApplyPageWrapper;